import { c as _c } from "react/compiler-runtime";
import { User01Icon } from '@untitledui-icons/react/line';
import { HeaderQuickMenuButton, HeaderQuickMenuLinkButton } from './HeaderQuickMenuCTA';
export function AccountButton(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <User01Icon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <HeaderQuickMenuButton {...props}>{t0};</HeaderQuickMenuButton>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function AccountLinkButton(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <User01Icon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <HeaderQuickMenuLinkButton {...props}>{t0};</HeaderQuickMenuLinkButton>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}